
import { AddBankTransferOutgoing, BankTransferOutgoing, BankTransferRequest, BankTransferResult, BankTransferReviewRequest, BankTransferSourceOfFunds, CustomerOutgoingFreezeRequest, CustomerOutgoingFreezeState, PaymentRequestPendingReview, PaymentRequestReviewResolutionRequest, PaymentRequestReviewResolutionResult, SourceOfFundsUploadRequest} from "../../../models/Orchestrator";
import { ApiPagedResult, PagedResult, Result } from "../../../models/Result";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";
import { httpService } from "../../HttpService";
import { ICrudApiService } from "../../ICrudApiService";

class OrchestratorApiService implements ICrudApiService<BankTransferOutgoing, AddBankTransferOutgoing> {
    baseApiUrl = process.env.REACT_APP_ORCHESTRATOR_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;
    path: string = "BankTransfers";
    pathSourceOfFunds: string = "MoneyTransfers";

    getAllPaged = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<BankTransferOutgoing[]>> => 
        await httpService.getPage<BankTransferOutgoing[]>(`${this.path}/get-all`, searchRequest, { baseURL: this.baseApiUrl });

    getPendingPaged = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<BankTransferOutgoing[]>> => 
        await httpService.getPage<BankTransferOutgoing[]>(`${this.path}/get-pending`, searchRequest, { baseURL: this.baseApiUrl });

    getPendingPaymentReviews = async (page: number, pageSize: number, search?: string): Promise<PagedResult<PaymentRequestPendingReview[]>> => {
        const query = new URLSearchParams({ page: page.toString(), pageSize: pageSize.toString() });
        if (search) {
            query.set("search", search);
        }

        const result = await httpService.get<ApiPagedResult<PaymentRequestPendingReview[]>>(
            `/PaymentRequests/pending-review?${query.toString()}`,
            { baseURL: this.baseApiUrl },
        );

        return {
            success: result.success,
            data: result.data?.data ?? [],
            message: result.message,
            status: result.status,
            totalCount: result.data?.totalCount ?? 0,
        };
    };

    resolvePaymentReview = async (paymentRequestId: string, request: PaymentRequestReviewResolutionRequest): Promise<Result<PaymentRequestReviewResolutionResult>> =>
        await httpService.post<PaymentRequestReviewResolutionResult>(`/PaymentRequests/${paymentRequestId}/review`, request, { baseURL: this.baseApiUrl });

    getSourceOfFunds = async (request:BankTransferRequest): Promise<Result<BankTransferSourceOfFunds[]>> => await httpService.post<BankTransferSourceOfFunds[]>(`/${this.pathSourceOfFunds}/get-source-of-funds`, request, { baseURL: this.baseApiUrl });

    updateSourceOfFunds = async (request:BankTransferSourceOfFunds): Promise<Result<BankTransferSourceOfFunds>> => await httpService.put<BankTransferSourceOfFunds>(`/${this.pathSourceOfFunds}/source-of-funds`, request, { baseURL: this.baseApiUrl });
        
    uploadSourceOfFunds = async (request:SourceOfFundsUploadRequest): Promise<Result<BankTransferResult>> => await httpService.post<BankTransferResult>(`/${this.pathSourceOfFunds}/upload-source-of-funds`, request, { baseURL: this.baseApiUrl });
            
    setReviewResolution = async (request:BankTransferReviewRequest): Promise<Result<BankTransferResult>> => await httpService.post<BankTransferResult>(`/${this.path}/outgoing-review`, request, { baseURL: this.baseApiUrl });

    releaseCustomerOutgoingFreeze = async (request:BankTransferRequest): Promise<Result<BankTransferResult>> => await httpService.post<BankTransferResult>(`/${this.path}/outgoing-unfreeze`, request, { baseURL: this.baseApiUrl });

    getCustomerOutgoingFreeze = async (request:CustomerOutgoingFreezeRequest): Promise<Result<CustomerOutgoingFreezeState>> => await httpService.post<CustomerOutgoingFreezeState>(`/${this.path}/customer-outgoing-freeze/status`, request, { baseURL: this.baseApiUrl });

    activateCustomerOutgoingFreeze = async (request:CustomerOutgoingFreezeRequest): Promise<Result<CustomerOutgoingFreezeState>> => await httpService.post<CustomerOutgoingFreezeState>(`/${this.path}/customer-outgoing-freeze/activate`, request, { baseURL: this.baseApiUrl });

    releaseCustomerOutgoingFreezeForCustomer = async (request:CustomerOutgoingFreezeRequest): Promise<Result<CustomerOutgoingFreezeState>> => await httpService.post<CustomerOutgoingFreezeState>(`/${this.path}/customer-outgoing-freeze/release`, request, { baseURL: this.baseApiUrl });

    setRiskNote = async (request:BankTransferOutgoing): Promise<Result<BankTransferOutgoing>> => await httpService.put<BankTransferOutgoing>(`/${this.path}/risk-note`, request, { baseURL: this.baseApiUrl });

    get = async (userId: number): Promise<Result<BankTransferOutgoing>> => { throw new Error("Method not implemented."); };

    create = async (): Promise<Result<BankTransferOutgoing>> => { throw new Error("Method not implemented."); };

    update = async (): Promise<Result<BankTransferOutgoing>> => { throw new Error("Method not implemented."); };

    delete = async (entityId: number): Promise<Result<void>> => { throw new Error("Method not implemented."); };
}

const orchestratorApiService = new OrchestratorApiService();

export { orchestratorApiService };
